import React from 'react';
import {useTranslation} from '../../../config/TranslationProvider';
import config from '../../../config/config';
import LocationsContent from '../content/LocationsContent';
import DefaultHeader from '../head/DefaultHeader';
import Title from './Title';

const Locations = () => {

    const title = useTranslation('locations_dresden_elbland');

    return (
        <>
            <Title>{title}</Title>
            <DefaultHeader image={config.images.pages.events} title={useTranslation('locations')}
            />
            <LocationsContent />
        </>
    );
};

export default Locations;
